import React from 'react'
import { Route, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useHasSitesOnProduction } from 'store'
import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'
import EmptyScreen from 'packages/ui/EmptyScreen'

import SilentMode from './SilentMode'

const Layout = () => {
  const {t} = useTranslation()
  const hasSitesOnProduction = useHasSitesOnProduction()
  return (
    <RouteGuard requiredRoles={['silent_mode']}>
      {
        hasSitesOnProduction
          ? <Outlet />
          : <EmptyScreen icon="comment-middle">{t('ui_elements.service_soon')}</EmptyScreen>
      }
    </RouteGuard>
  )
}

const SilentModeRoutes = ({ path = '/silent-mode' }) => [
  <Route path={path} key="silent-mode" element={<Layout />}>
    <Route path="" index key="silent-mode-home" element={<SilentMode />} />
  </Route>
]

export default SilentModeRoutes